var api = require("!../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.106.2_@swc+core@1.15.30_@swc+helpers@0.5.21__/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.106.2_@swc+core@1.15.30_@swc+helpers@0.5.21__/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../node_modules/.pnpm/postcss-loader@7.3.4_@typescript+typescript6@6.0.2_postcss@8.5.19_webpack@5.106.2_@swc+_fd23451be3c35649fcb584f4c1aa7fb4/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].use[0]!./inter.css");

            content = content.__esModule ? content.default : content;

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};